module.exports = __webpack_public_path__ + "static/media/plus-grey-dark.3773a3fa.svg";